import { z } from 'zod';
/** 시스템 프롬프트 한 항목 최대 길이 (공백 포함). server zod + web textarea 공용. */
export const MAX_SYSTEM_PROMPT_LENGTH = 2000;
export const MAX_SYSTEM_PROMPT_CHANGELOG_LENGTH = 200;
export const SystemPromptSourceSchema = z.enum(['manual', 'restore_default', 'create']);
const ActorSchema = z
    .object({
    userId: z.string().uuid(),
    email: z.string().nullable(),
    displayName: z.string().nullable(),
})
    .nullable();
export const SystemPromptSummarySchema = z.object({
    key: z.string(),
    label: z.string(),
    description: z.string(),
    isDefault: z.boolean(),
    updatedAt: z.string().nullable(),
    updatedBy: ActorSchema,
});
export const SystemPromptSummaryListSchema = z.object({
    prompts: z.array(SystemPromptSummarySchema),
});
export const SystemPromptDetailSchema = z.object({
    key: z.string(),
    label: z.string(),
    description: z.string(),
    hint: z.string().nullable(),
    currentValue: z.string(),
    defaultValue: z.string(),
    isDefault: z.boolean(),
    updatedAt: z.string().nullable(),
    updatedBy: ActorSchema,
});
export const SystemPromptVersionSchema = z.object({
    id: z.string().uuid(),
    key: z.string(),
    version: z.number().int().positive(),
    value: z.string().nullable(),
    source: SystemPromptSourceSchema,
    changelog: z.string().nullable(),
    createdAt: z.string(),
    createdBy: ActorSchema,
});
export const SystemPromptVersionListSchema = z.object({
    versions: z.array(SystemPromptVersionSchema),
});
export const SaveSystemPromptRequestSchema = z.object({
    value: z.string().max(MAX_SYSTEM_PROMPT_LENGTH),
    changelog: z.string().max(MAX_SYSTEM_PROMPT_CHANGELOG_LENGTH).optional(),
});
export const RestoreSystemPromptRequestSchema = z.object({
    changelog: z.string().max(MAX_SYSTEM_PROMPT_CHANGELOG_LENGTH).optional(),
});
//# sourceMappingURL=system-prompts.js.map